import { emptyLastMatchDayResultsWidgetState } from './../models/LastMatchDayResultsWidgetModel';
import { MutationTree } from 'vuex';
import { LeagueState, Settings, LeagueTableViewItem, NextMatchWidgetModel, emptyNextMatchWidgetModel, emptyLastMatchWidgetModel, LastMatchWidgetModel } from './models';
import Vue from 'vue';
import { MatchResultModel } from '../models/MatchResultModel';
import { MatchDayResultsModel } from '../models/MatchDayResultsModel';

export enum Mutations {
  GET_LEAGUE_SETTINGS_REQUEST = 'GET_LEAGUE_SETTINGS_REQUEST',
  GET_LEAGUE_SETTINGS_SUCCESS = 'GET_LEAGUE_SETTINGS_SUCCESS',
  GET_LEAGUE_SETTINGS_FAILURE = 'GET_LEAGUE_SETTINGS_FAILURE',
  GET_LEAGUE_TABLE_REQUEST = 'GET_LEAGUE_TABLE_REQUEST',
  GET_LEAGUE_TABLE_SUCCESS = 'GET_LEAGUE_TABLE_SUCCESS',
  GET_LEAGUE_TABLE_FAILURE = 'GET_LEAGUE_TABLE_FAILURE',
  GET_NEXT_MATCH_WIDGET_REQUEST = 'GET_NEXT_MATCH_WIDGET_REQUEST',
  GET_NEXT_MATCH_WIDGET_SUCCESS = 'GET_NEXT_MATCH_WIDGET_SUCCESS',
  GET_NEXT_MATCH_WIDGET_FAILURE = 'GET_NEXT_MATCH_WIDGET_FAILURE',
  GET_LAST_MATCH_WIDGET_REQUEST = 'GET_LAST_MATCH_WIDGET_REQUEST',
  GET_LAST_MATCH_WIDGET_SUCCESS = 'GET_LAST_MATCH_WIDGET_SUCCESS',
  GET_LAST_MATCH_WIDGET_FAILURE = 'GET_LAST_MATCH_WIDGET_FAILURE',
  GET_LAST_MATCH_DAY_RESULTS_WIDGET_REQUEST = 'GET_LAST_MATCH_DAY_RESULTS_WIDGET_REQUEST',
  GET_LAST_MATCH_DAY_RESULTS_WIDGET_SUCCESS = 'GET_LAST_MATCH_DAY_RESULTS_WIDGET_SUCCESS',
  GET_LAST_MATCH_DAY_RESULTS_WIDGET_FAILURE = 'GET_LAST_MATCH_DAY_RESULTS_WIDGET_FAILURE',
}

export const mutations: MutationTree<LeagueState> = {
  [Mutations.GET_LEAGUE_SETTINGS_REQUEST](state) {
    state.settings = undefined,
    state.loaded = false;
  },
  [Mutations.GET_LEAGUE_SETTINGS_SUCCESS](state, payload: Settings) {
    state.settings = payload;
    state.loaded = true;
  },
  [Mutations.GET_LEAGUE_SETTINGS_FAILURE](state) {
    state.settings = undefined;
    state.loaded = false;
  },
  [Mutations.GET_LEAGUE_TABLE_REQUEST](state) {
    state.leagueTable.isLoaded = false,
    state.leagueTable.leagueTableItems = [];
  },
  [Mutations.GET_LEAGUE_TABLE_SUCCESS](state, payload: LeagueTableViewItem[]) {
    state.leagueTable.isLoaded = true;
    state.leagueTable.leagueTableItems = payload;
  },
  [Mutations.GET_LEAGUE_TABLE_FAILURE](state) {
    state.leagueTable.isLoaded = false;
    state.leagueTable.leagueTableItems = [];
  },
  [Mutations.GET_NEXT_MATCH_WIDGET_REQUEST](state) {
    state.nextMatchWidget.isFetched = false,
    state.nextMatchWidget.nextMatch = emptyNextMatchWidgetModel;
  },
  [Mutations.GET_NEXT_MATCH_WIDGET_SUCCESS](state, payload: NextMatchWidgetModel) {
    state.nextMatchWidget.isFetched = true,
    state.nextMatchWidget.nextMatch = payload;
  },
  [Mutations.GET_NEXT_MATCH_WIDGET_FAILURE](state) {
    state.nextMatchWidget.isFetched = false,
    state.nextMatchWidget.nextMatch = emptyNextMatchWidgetModel;
  },
  [Mutations.GET_LAST_MATCH_WIDGET_REQUEST](state) {
    state.lastMatchWidget.isFetched = false,
    state.lastMatchWidget.lastMatch = emptyLastMatchWidgetModel;
  },
  [Mutations.GET_LAST_MATCH_WIDGET_SUCCESS](state, payload: LastMatchWidgetModel) {
    state.lastMatchWidget.isFetched = true,
    state.lastMatchWidget.lastMatch = payload;
  },
  [Mutations.GET_LAST_MATCH_WIDGET_FAILURE](state) {
    state.lastMatchWidget.isFetched = false,
    state.lastMatchWidget.lastMatch = emptyLastMatchWidgetModel;
  },
  [Mutations.GET_LAST_MATCH_DAY_RESULTS_WIDGET_REQUEST](state) {
    state.lastMatchDayResultsWidget = emptyLastMatchDayResultsWidgetState;
  },
  [Mutations.GET_LAST_MATCH_DAY_RESULTS_WIDGET_SUCCESS](state, payload: MatchDayResultsModel) {
    state.lastMatchDayResultsWidget.isFetched = true,
    state.lastMatchDayResultsWidget.lastMatchDayResults = payload;
  },
  [Mutations.GET_LAST_MATCH_WIDGET_FAILURE](state) {
    state.lastMatchDayResultsWidget = emptyLastMatchDayResultsWidgetState;
  },
};
